module.exports = __webpack_public_path__ + "static/media/GalleryImage18.db391dff.jpg";